import React from 'react';
import { X, FileText, AlertTriangle, Pill } from 'lucide-react';

export const DrugInfoModal = ({ farmaco, onClose }) => {
  if (!farmaco) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl max-w-lg w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-start mb-4">
            <div>
              <h3 className="text-xl font-bold" style={{ color: '#2A9FCB' }}>{farmaco.nome_commerciale}</h3>
              <p className="text-[#2A9FCB]/80">{farmaco.principio_attivo} {farmaco.concentrazione}</p>
            </div>
            <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-lg">
              <X className="w-5 h-5" />
            </button>
          </div>

          <div className="space-y-4">
            <div className="p-3 rounded-lg" style={{ background: '#F0FAF5' }}>
              <h4 className="font-semibold flex items-center gap-2 mb-2">
                <FileText className="w-4 h-4" /> Indicazioni
              </h4>
              <p className="text-sm text-[#2A9FCB]">{farmaco.indicazioni}</p>
            </div>

            <div className="p-3 rounded-lg bg-red-50">
              <h4 className="font-semibold flex items-center gap-2 mb-2 text-red-700">
                <AlertTriangle className="w-4 h-4" /> Controindicazioni
              </h4>
              <p className="text-sm text-red-700">{farmaco.controindicazioni}</p>
            </div>

            <div className="p-3 rounded-lg bg-blue-50">
              <h4 className="font-semibold flex items-center gap-2 mb-2 text-blue-700">
                <Pill className="w-4 h-4" /> Posologia
              </h4>
              <p className="text-sm text-blue-700">{farmaco.posologia_standard}</p>
              <p className="text-sm text-blue-600 mt-1">Durata: {farmaco.durata_consigliata}</p>
            </div>

            <div className="p-3 rounded-lg bg-gray-50">
              <h4 className="font-semibold mb-2">🧊 Conservazione</h4>
              <p className="text-sm text-[#2A9FCB]">{farmaco.conservazione}</p>
            </div>

            <div className="p-3 rounded-lg bg-purple-50">
              <h4 className="font-semibold mb-2">📦 Formati Disponibili</h4>
              <ul className="text-sm text-purple-700">
                {farmaco.formati?.map((f, i) => (
                  <li key={i}>• {f}</li>
                ))}
              </ul>
            </div>

            {farmaco.note && (
              <div className="p-3 rounded-lg bg-amber-50">
                <h4 className="font-semibold mb-2">📝 Note</h4>
                <p className="text-sm text-amber-700">{farmaco.note}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DrugInfoModal;
